export default {
  init() {
    const accordions = $('.accordion');
    if (accordions.length) {
      accordions.each(function() {
        const thisAccordion = $(this);
        const panels = thisAccordion.find('.panel');
        const allBody = thisAccordion.find('.panel-body');

        const closeOtherPanels = () => {
          allBody.each(function() {
            this.style.height = 0;
          });

          panels.removeClass('active');
        };

        panels.each(function() {
          const thisPanel = $(this);
          const header = thisPanel.find('.panel-header');
          const body = thisPanel.find('.panel-body').get(0);

          header.on('click', function(e) {
            e.preventDefault();

            if (!thisPanel.hasClass('active')) {
              closeOtherPanels();

              thisPanel.addClass('active');
              body.style.height = `${body.scrollHeight}px`;
            } else {
              thisPanel.removeClass('active');
              body.style.height = 0;
            }
          });
        });
      });
    }
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/components/accordions.js